import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/ui/SectionTitle';
import Section from '../../components/ui/Section';
import ProjectsTabs from './ProjectsTabs';
import projectsInfo from './websites-info/projects-info.js';
// import projectsTabsData from './projectsTabsData.js';

const ProjectsSection = () => {
  const tilteInfo = {
    subTitle: 'my portfolio',
    title: 'latest featured projects',
    description: `let's check my projects, for each project you can check project details & Live deployment.`,
  };

  return (
    <Section className="bg-light-trans">
      <SectionTitle className="" tilteInfo={tilteInfo} />
      <ProjectsTabs className="mt-12" tabsData={projectsInfo} />

      <Button
        className="mt-12 block w-fit mx-auto"
        variant="contained"
        component={Link}
        to="/contact"
      >
        Let's Contact Me
      </Button>
    </Section>
  );
};

export default ProjectsSection;
